<template>
  <div>
    <transition name="fade">
      <div v-if="!expanded" @click="expanded = true">Redefinir senha</div>
    </transition>

    <transition name="slide">
      <div v-if="expanded" class="form-box">
        <h3>Redefinir senha</h3>

        <!-- Senha Atual -->
        <div class="input-group">
          <label for="currentPassword">Senha Atual</label>
          <div class="password-input-wrapper">
            <input :type="showCurrentPassword ? 'text' : 'password'" id="currentPassword" placeholder="Digite sua senha atual" v-model="currentPassword" />
            <button type="button" class="visibility-toggle" @click="showCurrentPassword = !showCurrentPassword" tabindex="-1">
              <svg v-if="showCurrentPassword" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="currentColor">
                <path
                  d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
                />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="currentColor">
                <path
                  d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div style="height: 12px"></div>

        <!-- Nova Senha -->
        <div class="input-group">
          <label for="password">Nova Senha</label>
          <div class="password-input-wrapper">
            <input :type="showPassword ? 'text' : 'password'" id="password" placeholder="Digite sua nova senha" v-model="password" @input="validate" />
            <button type="button" class="visibility-toggle" @click="showPassword = !showPassword" tabindex="-1">
              <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="currentColor">
                <path
                  d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
                />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="currentColor">
                <path
                  d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div style="height: 12px"></div>

        <!-- Confirmar Senha -->
        <div class="input-group">
          <div class="password-input-wrapper">
            <input :type="showPassword ? 'text' : 'password'" id="confirmPassword" placeholder="Confirme sua nova senha" v-model="confirmPassword" @input="validate" />
          </div>
        </div>

        <div style="height: 12px"></div>

        <!-- Validation message -->
        <div v-if="error" class="error">{{ error }}</div>

        <button :disabled="loading || !password || !confirmPassword || !currentPassword" @click="submit" class="submit-button">
          <span v-if="!loading">Confirmar</span>
          <span v-else class="loading"> <div></div></span>
        </button>
      </div>
    </transition>

    <!-- Success -->
    <div v-if="success" class="success">{{ success }}</div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { api } from "roboflex-thalamus-request-handler/dist";
import { sso } from "roboflex-thalamus-sso-lib";

const expanded = ref(false);
const currentPassword = ref("");
const password = ref("");
const confirmPassword = ref("");
const error = ref("");
const loading = ref(false);
const success = ref("");
const showCurrentPassword = ref(false);
const showPassword = ref(false);

function validate() {
  error.value = "";
  success.value = "";

  const rules = [
    { test: /.{8,}/, msg: "Pelo menos 8 caracteres" },
    { test: /[A-Z]/, msg: "Uma letra maiúscula" },
    { test: /[a-z]/, msg: "Uma letra minúscula" },
    { test: /\d/, msg: "Pelo menos um número" },
    { test: /[^A-Za-z0-9]/, msg: "Pelo menos um carácter especial" },
  ];

  for (const rule of rules) {
    if (!rule.test.test(password.value)) {
      error.value = rule.msg;
      return;
    }
  }

  if (confirmPassword.value && password.value !== confirmPassword.value) {
    error.value = "As senhas não são iguais";
  }
}

async function submit() {
  loading.value = true;

try {
  const response = await api.post("/usuario/senha/alterar", {
    usuario_id: sso.getUsuarioLogado().id,
    current_password: currentPassword.value,
    new_password: password.value,
    new_password_confirmation: confirmPassword.value,
  });

  console.log("response:", response.data);

  if (response.data.error) {
    error.value = response.data.error;

  } else if (response.data.message === "Senha atual incorreta") {
    error.value = "Senha atual incorreta";
    password.value = "";

  } else if (response.data.message === "Senha alterada com sucesso") {
    success.value = "Senha redefinida com sucesso!";
    currentPassword.value = "";
    password.value = "";
    confirmPassword.value = "";
    expanded.value = false;
  }

} catch (err) {
  console.log("catch error:", err);

  if (err.response?.data?.message === "Senha atual incorreta") {
    error.value = "Senha atual incorreta";
    currentPassword.value = "";
  } else {
    error.value = "Erro ao redefinir senha. " + (err.response?.data?.message || "");
  }

} finally {
  loading.value = false;
}
}
</script>

<style scoped>
.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

input {
  padding: 10px;
  padding-right: 40px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 15px;
  width: 100%;
  box-sizing: border-box;
}

.visibility-toggle {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: color 0.2s;
  z-index: 1;
}

.visibility-toggle:hover {
  color: #333;
}

.visibility-toggle svg {
  display: block;
}

.submit-button {
  padding: 12px;
  border: none;
  border-radius: 16px;
  background: var(--cor-primaria);
  color: white;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  margin-right: 0px;
  width: 100%;
}

.submit-button:disabled {
  background: var(--cor-primaria);
  cursor: not-allowed;
  opacity: 0.6;
}

.submit-button:not(:disabled):hover {
  background: #3e5bd0;
}

.error {
  color: var(--cor-erro);
  font-size: 0.9rem;
  font-weight: bold;
}

.success {
  color: var(--cor-sucesso);
  font-size: 0.9rem;
  font-weight: bold;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active {
  transition: all 0.25s ease;
}
.slide-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
</style>
